import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useLanguage } from '../../../context/language';
import { getStrLang } from '../../Translate';
import { getAceiteTermos, getLPCashInfo } from '../../../api/fastcoinService';
import toast, { Toaster } from 'react-hot-toast';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutButton from './CheckoutButton'

const GooglePay = (props) => {

    const { translate, lang, orderFromDeposit } = useLanguage();

    // const stripePromise = loadStripe('pk_test_51My17yGpCEmlya7PYeFBgCaXbpHI1nQgDleA6IeWmA7aIwfHcHjYH5cOG6GLLhbpAv3GQQ7QXGvpFN5pef3FjcuK00Mp2Z5nGK');

    const stripePromise = loadStripe('pk_live_51My17yGpCEmlya7Pcg5Tt7tu6zskfmGwZRzWqMHP10KfM4zPdp2fGcrkNbLI0dr1RAwAxH17cn0dD5klxDEoCzT4002sHMGuxX');
    
    const country = sessionStorage.getItem("country").toLocaleLowerCase();


    useEffect(() => {

        function validarTermos() {
            getAceiteTermos(sessionStorage.getItem("order_no"))
                .then(res => {
                    if (res !== undefined) {
                        props.setShowTermos(false);
                    } else {
                        props.setShowTermos(true);
                    }
                    translate();
                })
                .catch(err => {
                    if (err.error.includes("Could not find")) {
                        console.log(err);
                    } else {
                        console.log(err);
                        alert("Please talk with the administrator");
                    }
                    props.setShowTermos(true);
                })
        }
        if (orderFromDeposit !== "") {
            validarTermos();
        }
    }, []);


    useEffect(() => {
        translate();
    }, [translate, country]);


    return (
        <>
            <Toaster
                toastOptions={{
                    className: '',
                    style: {
                        border: '1px solid #0d4fb8',
                        color: '#0d4fb8',
                        padding: '12px',
                        top: '300px',
                        //  position: 'relative',
                    },
                }}
            />
            <div className="row">
                <div className='col-md-12 justify-content-center'>
                    <Elements stripe={stripePromise}>
                        <CheckoutButton />
                    </Elements>
                </div>
            </div>


        </>)
}

export default GooglePay;